import { IonItem, IonModal, IonTitle, IonButton, IonHeader } from "@ionic/react"
import { useState } from "react"
import { API_URL } from "../../../../actions/settings"
import NotificationPopUp from "../../../extras/NotificationPopUp"
import AE2Input from "../../../elements/AE2Input"

interface Props{
    opened:boolean,
    setShowUtilityProviderModal:any,
    setUtilityProviders:any
}

async function addUtilityProvider(data:any,token:any) {

    return fetch(`${API_URL}/utility_provider`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },
      body: JSON.stringify(data)

    })
      .then(data => data.json())
   }


const startForm = {
    "name": "",
    "urjanet_name": ""
}
const errorsForm:any = {
    "name": "",
    "urjanet_name": ""
}

const ProviderForm:React.FC<Props> = ({opened,setShowUtilityProviderModal,setUtilityProviders}) =>{
    const [form, setForm] = useState(startForm)
    const [errors, setErrors] = useState(errorsForm)

    const validate = (name:string, val:any) => {
        switch (name) {
            case 'name':
                if(val === null || val.length <=1){
                    return {name:'Provider Name Must Be Longer Than 2 Characters'}
                }
                else{
                    return {name:''}
                }

            case 'urjanet_name':
                if(val === null || val.length <=1 ){
                    return {urjanet_name:'Urjanet Name Must Be Longer Than 2 Characters'}
                }
                else{
                    return {urjanet_name:''}
                }
            default:
                break;
        }
    }

    const validateAll = (form:any) => {
        let validation = errorsForm
        let valid = true
        for (let item in form){

            validation = {...validation, ...validate(item,form[item])}

        }
        setErrors({...errors,...validation})

        for(let val in validation){
            if (validation[val] !== ''){
                valid = false;
            }

        }

        return valid
        }

    const handleFormChange = (value:any,name:string) => {
        setErrors({...errors, ...validate(name,value) })
        setForm((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
    }

    const handleSubmit = async (form:any) => {
        const token:any = localStorage.getItem('token')
        const valid = validateAll(form) || false
        if(valid){
        const res = await addUtilityProvider(form,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                setForm(startForm)
                setShowUtilityProviderModal(false)
                setUtilityProviders((prevState:any) => {
                    return [
                        ...prevState,
                        res.data
                    ]
                })
                NotificationPopUp('success','Provider Added')

            }
            else{
                NotificationPopUp('Error',res.detail||res.ERROR,res.error)
            }
        }
    }

    return (
        <IonModal id="providerModal" isOpen={opened} onDidDismiss={()=>setShowUtilityProviderModal(false)}>
                <IonHeader><IonTitle>Add Utility Provider Form</IonTitle></IonHeader>
                    <form>
                        <IonItem>
                            <AE2Input label='Provider Name:' labelPlacement='stacked'  errorText={errors.name} value={form.name} placeholder="Provider Name" onIonInput={(e)=> handleFormChange(e.detail.value!,'name')}></AE2Input>
                        </IonItem>
                        <IonItem>
                            <AE2Input label='Provider Urjanet Name:' labelPlacement='stacked'  errorText={errors.urjanet_name} value={form.urjanet_name} placeholder="Provider Urjanet Name" onIonInput={(e)=> handleFormChange(e.detail.value!,'urjanet_name')}></AE2Input>
                        </IonItem>
                    </form>
                    <div className='buttons'>
                    <IonButton onClick={()=>handleSubmit(form)} >Add</IonButton>
                    <IonButton onClick={()=>setShowUtilityProviderModal(false)} color='danger'>cancel</IonButton>
                    </div>
            </IonModal>
    )
}

export default ProviderForm